export default __webpack_public_path__ + "static/media/forging.d2a77eea.webp";